export default {
    isAppUpdated: false,
    notification: {
        show: false,
        type: '',
        message: '',
        action: null,
        timeout: -1
    },
    mainLoader: false,
    circularLoader: false,
    progress: {
        show: false,
        value: 0,
        fileName: null
    },
    errorCodes: [],
    hasCamera: false,
    savedPagination: {
        moduleName: null,
        pagination: null,
        settings: null
    },
    selectedListItemId: null
}
